import Head from "../modules/Head";
import "../modules/global.scss";
import React, { useState, useEffect } from "react";
import "./Pocetna.scss";
import "../components/Background.scss";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import "../components/FormValidationsWarning.scss";
import FizickoLiceLoginForm from "./FizickoLiceLoginForm";
import { useFormik, Formik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import config from "../config.json";

function Pocetna() {
  const { baseUrl, token } = config;
  const navigate = useNavigate();
  const [responseMessage, setResponseMessage] = useState("");

  useEffect(() => {
    const cookies = new Cookies();
    const pravnoLice = cookies.get("pravnoLice");

    if (pravnoLice) {
      navigate("/login-pravnog-lica");
    }
  }, [navigate]);

  const onSubmit = async (values, { resetForm }) => {
    try {
      const response = await axios.post(
        `${baseUrl}/auth/login-pravnog-lica`,
        values,
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      const email = response.data.email;
      const korisnickoIme = response.data.korisnickoIme;
      const ime = response.data.ime;
      const logotip = response.data.logotip;
      const telefon = response.data.telefon;

      const pravnoLice = { email, korisnickoIme, ime, logotip, telefon };

      const pravnoLiceString = JSON.stringify(pravnoLice);

      if (values.zapamtiMe) {
        const cookies = new Cookies(null, {
          path: "/",
          expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
        });
        cookies.set("pravnoLice", pravnoLiceString, { path: "/" });
      } else {
        const cookies = new Cookies();
        cookies.set("pravnoLice", pravnoLiceString, { path: "/" });
      }

      setResponseMessage(response.data.message);
      navigate("/login-pravnog-lica");
    } catch (error) {
      setResponseMessage(error.response.data.message);
    }
    resetForm();
  };
  const { handleBlur, handleChange, handleSubmit, values, errors, touched } =
    useFormik({
      initialValues: {
        korisnickoIme: "",
        password: "",
        zapamtiMe: false,
      },
      onSubmit,
      validationSchema: Yup.object({
        korisnickoIme: Yup.string()
          .matches(/^[A-Za-z]+$/, "Ime ne može sadržavati brojeve.")
          .required("Niste unijeli ime."),
        password: Yup.string()
          .min(8, "Lozinka mora sadržavati najmanje 8 znakova")
          .required("Niste unijeli lozinku."),
      }),
    });

  return (
    <div>
      <Head title="Početna stranica" />
      <img
        id="background"
        src={require("../imgs/homePageBackground.png")}
        alt="Background"
      ></img>
      <img
        className="logo-linker"
        src={require("../imgs/Logo-text-linker.png")}
        alt="LogoTextLinker"
      ></img>
      <img
        id="logo"
        src={require("../imgs/LogoTitle.svg").default}
        alt="LogoTitle"
      />
      <div className="top-left">Dobrodošli na</div>
      <div className="top-left-lower">Brza i jednostavna veza</div>
      <div className="top-left-lower-2">do poslova i talenata !</div>
      <div className="center">PRIJAVI SE</div>
      <div className="center-second-row">
        Molimo odaberite profil i prijavite se na vaš račun.
      </div>

      <div className="box-pravno-lice"></div>
      <div className="box-pravno-lice-text-naslov">PRAVNO LICE</div>
      <div className="inputFieldsPravnoLice">
        <label id="labelKorisnickoimePravnoLice" htmlFor="name">
          Korisničko ime
        </label>
        <form
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSubmit();
            }
          }}
        >
          <input
            type="text"
            name="korisnickoIme"
            id="nameInputPravnoLice"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.korisnickoIme}
          />
          {touched.korisnickoIme && errors.korisnickoIme ? (
            <span className="input-error" id="nameInputPravnoLice-error">
              {errors.korisnickoIme}
            </span>
          ) : null}

          <label id="labelLozinkaPravnoLice" htmlFor="lozinkaPravnoLice">
            Lozinka
          </label>
          <input
            type="password"
            name="password"
            id="passwordInputPravnoLice"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password}
          />
          {touched.password && errors.password ? (
            <span className="input-error" id="passwordInputPravnoLice-error">
              {errors.password}
            </span>
          ) : null}
        </form>
        <form onSubmit={handleSubmit}>
          <div>
            <label
              id="labelZapamtiMePravnoLice"
              className="radioButtonLabelPravnoLice"
            >
              <input
                className="radioButtonPravnoLice"
                type="checkbox"
                name="zapamtiMe"
                onChange={handleChange}
                checked={values.zapamtiMe}
              />
              Zapamti me
            </label>
          </div>
          <Link
            to="/zaboravljen-password-pravno-lice"
            id="forgottenPasswordLinkPravnoLice"
            className="forgottenPasswordLink"
          >
            Zaboravio/la si lozinku ?
          </Link>
          <Button
            type="submit"
            className="prijaviseButtonPravnoLice btn btn-primary btn-lg"
            variant="danger"
          >
            PRIJAVI SE
          </Button>
          <Link
            to="/registracija-pravnog-lica"
            id="noviKorisnikPravnoLice"
            className="forgottenPasswordLink"
          >
            Novi korisnik ? Registrujte se
          </Link>
        </form>
        <div>
          <Formik />
          <Formik>{FizickoLiceLoginForm}</Formik>
          <b id="responseMessagePocetna">{responseMessage}</b>
        </div>
      </div>
    </div>
  );
}

export default Pocetna;
